import { useSelector } from 'react-redux';
import { Children } from 'react';
export const SchoolRoleFilter = ({ roles, children }) => {
  const  role  = useSelector(({ user }) => user && user.role); 
  if (roles &&(!role || !roles.includes(role)))
    return null; 
  return  Children.only(children); 
};
